export const LOGOUT_URL = `${process.env.API_HOST}/saml/logout?slo=1`;
export const DEFAULT_INACTIVITY_TIMEOUT = 180;
